/** ФИО пользователя ЛК клиента. */
export function formatClientLkUserFio(user) {
  if (!user) return "—";
  return [user.last_name, user.first_name, user.father_name]
    .filter(Boolean)
    .join(" ")
    .trim() || "—";
}

/** «Да» / «Нет» для булева поля. */
export function formatClientLkYesNo(value) {
  return value ? "Да" : "Нет";
}

/**
 * id_production → названия площадок через справочник productions.
 * Неизвестные id пропускаются; если ничего не найдено — «—».
 */
export function mapProductionIdsToNames(idProduction, productions) {
  const ids = Array.isArray(idProduction) ? idProduction : [];
  if (ids.length === 0) return "—";

  const byId = new Map();
  (productions ?? []).forEach((p) => {
    if (p?.id != null) {
      byId.set(Number(p.id), p.name_production || p.name || "");
    }
  });

  const names = ids
    .map((id) => byId.get(Number(id)))
    .filter((name) => name && String(name).trim());

  return names.length > 0 ? names.join(", ") : "—";
}

export function clientLkUsersNeedProductions(users, productions) {
  if (!Array.isArray(users) || users.length === 0) return false;
  const hasIds = users.some(
    (u) => Array.isArray(u.id_production) && u.id_production.length > 0,
  );
  const prodList = productions ?? [];
  return hasIds && prodList.length === 0;
}

/** Обновление payload GET client_lk_users после POST register/reset. */
export function mergeClientLkUserIntoPayload(existingPayload, user, companyId) {
  if (!user?.id) {
    return existingPayload;
  }
  const prev = existingPayload ?? {};
  const users = Array.isArray(prev.users) ? [...prev.users] : [];
  const idx = users.findIndex((u) => u.id === user.id);
  if (idx >= 0) {
    users[idx] = { ...users[idx], ...user };
  } else {
    users.push(user);
  }
  return {
    ...prev,
    company_id: companyId ?? prev.company_id,
    registered_in_client_lk: true,
    users,
    users_count: users.length,
  };
}
